import { profile } from "../../data/resume";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-hair bg-ink text-paper"
    >
      <div className="mx-auto max-w-[1400px] px-6 sm:px-12 lg:px-20 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <span className="font-serif text-lg">{profile.name}</span>
        <span className="font-mono text-xs uppercase tracking-[0.22em] text-paper/50">
          © {new Date().getFullYear()} — {profile.currentRole}, {profile.currentCompany}
        </span>
      </div>
    </footer>
  );
};
